import React from 'react';
import PropTypes from 'prop-types';
import NewsSearchControls from "./NewsSearchControls";
import NewsSearchContent from "./NewsSearchContent";
import Listing from "../../listing/js/Listing";
import ListingPagesInfo from "../../listing/js/ListingPagesInfo";
import ListingHeader from "../../listing/js/ListingHeader";
import ListingContentWrapper from "../../listing/js/ListingContentWrapper";
import {getDefaultFilters} from "../../listing/js/listing-helper";
import ListingControlsWrapper from "../../listing/js/ListingControlsWrapper";

export default class NewsSearch extends React.PureComponent {
    constructor(props) {
        super(props);

        this.emptyResultMessage = 'I am afraid we don\'t have any news.\nPlease try making your search a little wider.';

        this.defaultFilters = getDefaultFilters(props.options.filters);
    }

    render() {
        return (
            <Listing options={this.props.options} defaultFilters={this.defaultFilters}
                     render={({
                                  isInitialRequestFulfilled,
                                  onFiltersChange,
                                  controls,
                                  filters,
                                  items,
                                  pagination
                              }) => (
                         <div>
                             <ListingHeader>
                                 <div className="news-search__pages-info">
                                     <ListingPagesInfo itemsCount={items.length}
                                                       pagination={pagination}/>
                                 </div>
                                 <ListingControlsWrapper controls={controls}>
                                     <NewsSearchControls onFiltersChange={onFiltersChange}
                                                   filters={filters}
                                                   options={this.props.options}/>
                                 </ListingControlsWrapper>
                             </ListingHeader>
                             <div className="listing__content">
                                 <div className="container">
                                     <ListingContentWrapper emptyResultMessage={this.emptyResultMessage}
                                                            isInitialRequestFulfilled={isInitialRequestFulfilled}
                                                            itemsCount={items.length}>
                                         <NewsSearchContent items={items}/>
                                     </ListingContentWrapper>
                                 </div>
                             </div>
                         </div>
                     )}/>
        );
    }
}

NewsSearch.propTypes = {
    options: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./app/components/news-search/js/NewsSearch.js